import _slicedToArray from "/codebuild/output/src964116771/src/rosteroo-landing/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';

var useScroll = function useScroll() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      scroll = _useState2[0],
      setScroll = _useState2[1];

  useEffect(function () {
    window.addEventListener('scroll', scrollHandler);
    return function () {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  var scrollHandler = function scrollHandler() {
    setScroll(window.scrollY);
  };

  return scroll;
};

export default useScroll;